import { Navigate, useNavigate, useParams } from "react-router-dom";
import { FaContext, useLoad } from "@/components/fa/kit";
import { FinanceGate } from "@/components/crm/FinanceLock";
import { FaDashboard } from "@/components/fa/FaDashboard";
import { ProjectLedgers } from "@/components/fa/ProjectLedger";
import { RequestList } from "@/components/fa/Requests";
import { BillList } from "@/components/fa/Bills";
import { FaVendors } from "@/components/fa/FaVendors";
import { ApprovalCentre, Credits } from "@/components/fa/Approvals";
import { Statements, AuditLog, FaSettings } from "@/components/fa/Admin";
import { DutyRequests, DutyExceptions } from "@/components/fa/Duty";
import { HolidayCalendar } from "@/components/fa/Holidays";

const ACCOUNTS = [
  { key: "dashboard", label: "Finance dashboard", show: (m) => m.finance, el: <FaDashboard /> },
  { key: "projects", label: "Project finance", show: (m) => m.finance || m.leads.length, el: <ProjectLedgers /> },
  { key: "advances", label: "Employee advances", el: <RequestList kinds="employee_advance" newKind="employee_advance" title="Employee advances" testid="advances" /> },
  { key: "expenses", label: "Expenses & reimbursements", el: <><BillList kind="employee" title="Employee expense bills" testid="emp-bills" /><RequestList kinds="reimbursement" title="Reimbursements" testid="reimbursements" /></> },
  { key: "vendors", label: "Vendor management", el: <FaVendors /> },
  { key: "vendor-bills", label: "Vendor bills & payments", el: <><BillList kind="vendor" title="Vendor bills" testid="vendor-bills" /><RequestList kinds="vendor_advance,vendor_payment" newKind="vendor_advance" title="Vendor advances & payments" testid="vendor-payments" /></> },
  { key: "approvals", label: "Approval centre", el: <ApprovalCentre /> },
  { key: "credits", label: "Carry-forward & reconciliation", el: <Credits /> },
  { key: "statements", label: "PDF statements", el: <Statements /> },
  { key: "audit", label: "Finance audit log", show: (m) => m.finance, el: <AuditLog /> },
  { key: "settings", label: "Notification & email settings", show: (m) => m.finance || m.admin, el: <FaSettings /> },
];
const DUTY = [
  { key: "requests", label: "Official event duty requests", el: <DutyRequests /> },
  { key: "exceptions", label: "Attendance exceptions", el: <DutyExceptions /> },
  { key: "holidays", label: "Holidays & weekly offs", el: <HolidayCalendar /> },
];

function FaHub({ base, title, tabs, locked }) {
  const { section } = useParams();
  const nav = useNavigate();
  const [me] = useLoad("/fa/me");
  if (!me) return <div className="p-10 text-sm text-zinc-500">Loading…</div>;
  if (locked && !me.finance) return <div data-testid="fa-no-access" className="rounded-2xl border border-[#D6C6B0] bg-white/70 p-16 text-center text-sm text-zinc-600">Finance & Accounts is limited to the Accounts department, Management, CEO, Founder and Owner.</div>;
  const list = tabs.filter((t) => !t.show || t.show(me));
  const cur = list.find((t) => t.key === section);
  if (!cur) return <Navigate to={`${base}/${list[0].key}`} replace />;
  return (
    <FaContext.Provider value={me}>
      <div className="space-y-5" data-testid={`fa-hub-${base.slice(1)}`}>
        <div className="flex flex-col gap-3 fade-up">
          <h1 data-testid="page-title" className="text-2xl font-extrabold tracking-tight text-zinc-900 sm:text-[28px]">{title}</h1>
          <div className="thin-scroll flex max-w-full gap-1 overflow-x-auto rounded-xl border border-[#D6C6B0] bg-white/70 p-1">
            {list.map((t) => (
              <button key={t.key} data-testid={`fa-tab-${t.key}`} onClick={() => nav(`${base}/${t.key}`)}
                className={`whitespace-nowrap rounded-lg px-3.5 py-1.5 text-xs font-bold transition-colors ${t.key === cur.key ? "bg-[#8B7356] text-white" : "text-zinc-600 hover:text-[#8B7356]"}`}>{t.label}</button>
            ))}
          </div>
        </div>
        <div key={cur.key} className="space-y-8">{cur.el}</div>
      </div>
    </FaContext.Provider>
  );
}

export default function AccountsPage({ duty }) {
  return duty ? <FaHub base="/duty" title="Event Duty & Attendance" tabs={DUTY} />
    : <FinanceGate key="accounts" title="Finance & Accounts Management"><FaHub base="/accounts" title="Finance & Accounts Management" tabs={ACCOUNTS} locked /></FinanceGate>;
}
